<template>
  <div class="emoticons">

    <div v-for="icon in Object.keys(emoticons)"
         class="emoticon"
         title="发送此时心情"
         @click="sendCommand(':' + icon)">
      <img :src="'emoticon/' + icon + '.svg'" width="26">
    </div>

    <div class="field has-addons">
      <div class="control">
        <input class="input is-rounded is-small is-fullwidth"
               placeholder="暂未开启回复"
               type="text">
      </div>
      <div class="control">
        <button class="button is-small is-rounded">
          <span>发送</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  data () {
    return {
      IClassroom,
      emoticons: {
        'handsup': '举手',
        'focus': '认真',
        'happy': '开心',
        'sad': '难过',
        'sleepy': '睡着了',
        'think': '思考中',
        'dizzy': '发困'
      }
    }
  },
  methods: {
    sendCommand (bubble) {
      IClassroom.showUserBubble(0, bubble)
    }
  }
}
</script>

<style lang="stylus" scoped>
.emoticons {
  display flex
  align-items center

  .field {
    margin 0 .5rem
  }
}

.emoticon {
  padding 8px
  height 42px
  position relative
  cursor: pointer;

  &:hover {
    background $neBg
  }

  .text {
    position absolute
    white-space nowrap
    left 50%
    bottom -1px
    font-size 12px
    transform translateX(-50%) scale(0.8)
  }

}

</style>
